import client from './client';

// Gốc media (server origin, bỏ '/api') để mở tệp đã upload.
export const MEDIA_BASE = (import.meta.env.VITE_API_URL || 'https://funnytask.net/api').replace(/\/api\/?$/, '');
// Chuẩn hoá đường dẫn tệp upload: LUÔN đi qua MEDIA_BASE (đã gồm '/api'). nginx chỉ proxy '/api'
// về backend; '/uploads' trần (kể cả url tuyệt đối cũ lưu thiếu '/api') rơi vào SPA fallback -> trả
// HTML -> ảnh vỡ. Trích phần '/uploads/<tên>' rồi ghép lại '<api>/uploads/<tên>' cho chắc chắn.
export const mediaUrl = (u) => {
  if (!u) return '';
  if (u.startsWith('data:')) return u;
  const m = u.match(/\/uploads\/[^?#]+/);
  if (m) return MEDIA_BASE.replace(/\/api\/?$/, '') + '/api' + m[0];
  return u.startsWith('http') ? u : MEDIA_BASE + u;
};

export const uploadChatFiles = (files) => {
  const fd = new FormData();
  [...files].forEach((f) => fd.append('files', f));
  return client.post('/chat/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};

export const chatUsers = () => client.get('/chat/users').then((r) => r.data);
export const chatPresence = () => client.get('/chat/presence').then((r) => r.data);
export const listConversations = () => client.get('/chat/conversations').then((r) => r.data);
export const openDirect = (userId) => client.post('/chat/direct', { userId }).then((r) => r.data);
export const createGroup = (payload) => client.post('/chat/group', payload).then((r) => r.data);
export const listMessages = (id, params) =>
  client.get(`/chat/conversations/${id}/messages`, { params }).then((r) => r.data);
export const sendMessage = (id, text, extra = {}) =>
  client.post(`/chat/conversations/${id}/messages`, { text, ...extra }).then((r) => r.data);
export const markRead = (id) => client.post(`/chat/conversations/${id}/read`).then((r) => r.data);
// Thả/đổi/bỏ cảm xúc 1 tin (emoji rỗng = bỏ). Chỉ tin người khác.
export const reactMessage = (messageId, emoji) => client.post(`/chat/messages/${messageId}/react`, { emoji }).then((r) => r.data);
export const REACTION_EMOJIS = ['❤️', '👍', '😆', '😮', '😢', '😠'];
export const addGroupMember = (convId, userId) => client.post(`/chat/conversations/${convId}/members`, { userId }).then((r) => r.data);
export const removeGroupMember = (convId, userId) => client.delete(`/chat/conversations/${convId}/members/${userId}`).then((r) => r.data);
export const renameGroup = (convId, name) => client.patch(`/chat/conversations/${convId}/name`, { name }).then((r) => r.data);
export const getVapidKey = () => client.get('/chat/push/key').then((r) => r.data);
export const subscribePush = (subscription) => client.post('/chat/push/subscribe', { subscription }).then((r) => r.data);
export const testPush = () => client.post('/chat/push/test').then((r) => r.data);